export const BASE_URL = "https://api.ngaanepal.org"